import {
	SET_ACCOUNTS,
	SET_ACCOUNT,
	CLEAR_ACCOUNTS,
	CLEAR_ACCOUNT,
	ADD_ACCOUNT,
	UPDATE_ACCOUNT,
	REMOVE_ACCOUNT,
} from './actionTypes';

export const account = (state = {}, action) => {
	switch (action.type) {
		case SET_ACCOUNT:
			return action.payload;
		case UPDATE_ACCOUNT:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_ACCOUNT:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_ACCOUNTS:
			return action.payload;
		case ADD_ACCOUNT:
			return [...state, action.payload];
		case UPDATE_ACCOUNT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_ACCOUNT:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_ACCOUNTS:
			return [];
		default:
			return state;
	}
};
